import { Quote, Sparkles } from 'lucide-react';
import { DiscoveryCard } from './discovery-card';
import { SourceLinks } from '@/components/ui/source-links';

interface WordplayCardProps {
  wordplay: {
    originalWord: string;
    transliteration: string;
    translation: string;
    explanation: string;
    ref?: string;
    sources?: Source[];
  };
}

export function WordplayCard({
  wordplay
}: WordplayCardProps) {
  return (
    <DiscoveryCard
      isExpanded={true}
      onToggle={() => { }}
      canExpand={false}
      icon={Quote}
      header={
        <div className="flex flex-col gap-3 flex-1 min-w-0 relative z-10">
          <div className="flex items-center justify-between gap-2">
            <div className="flex flex-col">
              <h4 className="text-xl font-serif font-medium tracking-tight text-foreground/90 leading-tight">
                {wordplay.originalWord}
              </h4>
              <span className="text-xs italic text-muted-foreground">({wordplay.transliteration})</span>
            </div>
            {wordplay.ref && (
              <span className="text-xs font-medium text-muted-foreground bg-muted/50 px-2 py-0.5 rounded-full">
                {wordplay.ref}
              </span>
            )}
          </div>
        </div>
      }
    >
      <div className="space-y-6 mt-1 relative z-10">
        <div className="grid grid-cols-2 gap-4 px-1">
          <div className="space-y-1.5">
            <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-primary/60">Translation</div>
            <p className="text-sm text-foreground/70 font-light leading-relaxed">{wordplay.translation}</p>
          </div>
          <div className="space-y-1.5 text-right">
            <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-primary/60">Original</div>
            <p className="text-sm font-serif text-foreground/90">{wordplay.originalWord}</p>
          </div>
        </div>

        <div className="space-y-1.5 px-1">
          <p className="text-sm text-foreground/70 font-light leading-relaxed">{wordplay.explanation}</p>
        </div>

        {wordplay.sources && wordplay.sources.length > 0 && (
          <div className="pt-4 border-t border-border/10">
            <SourceLinks sources={wordplay.sources} />
          </div>
        )}
      </div>
    </DiscoveryCard>
  );
}
